import { Info, CheckCircle2, AlertTriangle, XCircle, X } from 'lucide-react';
import { C, FONTS } from '../tokens/design';
import { useAlert } from '../context/AlertContext';

const TYPE_STYLES = {
  info:    { bg: `${C.sky}12`, border: `${C.sky}33`, color: C.sky, Icon: Info },
  success: { bg: `${C.grn}12`, border: `${C.grn}33`, color: C.grn, Icon: CheckCircle2 },
  warning: { bg: `${C.amb}12`, border: `${C.amb}33`, color: C.amb, Icon: AlertTriangle },
  error:   { bg: C.redBg,      border: `${C.red}33`, color: C.red, Icon: XCircle },
};

export default function AlertBanner() {
  const { alerts, dismissAlert } = useAlert();
  if (alerts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', top: 12, right: 12, zIndex: 10000,
      display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 400,
    }}>
      {alerts.map(alert => {
        const s = TYPE_STYLES[alert.type] || TYPE_STYLES.info;
        return (
          <div key={alert.id} style={{
            padding: '10px 14px', borderRadius: 8,
            background: s.bg, border: `1px solid ${s.border}`,
            color: s.color, fontSize: 12, fontFamily: FONTS.mono, fontWeight: 600,
            display: 'flex', alignItems: 'center', gap: 8,
            animation: 'fadeIn 0.2s ease',
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          }}>
            <s.Icon size={16} style={{ flexShrink: 0 }} />
            <span style={{ flex: 1 }}>{alert.message}</span>
            <button onClick={() => dismissAlert(alert.id)} style={{
              background: 'none', border: 'none', color: s.color,
              cursor: 'pointer', padding: 0, lineHeight: 1, flexShrink: 0, display: 'inline-flex',
            }}><X size={14} /></button>
          </div>
        );
      })}
    </div>
  );
}
